import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Content.css';
import MovieCard from './MovieCard';

// Sample movie data
const movies = [
  {
    id: 1,
    title: 'The Matrix',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    rating: 8.7,
    year: 1999,
    description: 'A computer hacker learns from mysterious rebels about the true nature of his reality and his role in the war against its controllers.',
    trailerUrl: 'https://www.youtube.com/embed/vKQi3bBA1y8'
  },
  {
    id: 2,
    title: 'Inception',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_.jpg',
    rating: 8.8,
    year: 2010,
    description: 'A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea into the mind of a C.E.O.',
    trailerUrl: 'https://www.youtube.com/embed/YoHD9XEInc0'
  },
  {
    id: 3,
    title: 'Interstellar',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BZjdkOTU3MDktN2IxOS00OGEyLWFmMjktY2FiMmZkNWIyODZiXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    rating: 8.6,
    year: 2014,
    description: 'A team of explorers travel through a wormhole in space in an attempt to ensure humanity\'s survival.',
    trailerUrl: 'https://www.youtube.com/embed/zSWdZVtXT7E'
  },
  {
    id: 4,
    title: 'The Shawshank Redemption',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDE3ODcxYzMtY2YzZC00NmNlLWJiNDMtZDViZWM2MzIxZDYwXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg',
    rating: 9.3,
    year: 1994,
    description: 'Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.',
    trailerUrl: 'https://www.youtube.com/embed/6hB3S9bIaco'
  },
  {
    id: 5,
    title: 'The Dark Knight',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTMxNTMwODM0NF5BMl5BanBnXkFtZTcwODAyMTk2Mw@@._V1_.jpg',
    rating: 9.0,
    year: 2008,
    description: 'When the menace known as the Joker wreaks havoc and chaos on the people of Gotham, Batman must accept one of the greatest psychological and physical tests of his ability to fight injustice.',
    trailerUrl: 'https://www.youtube.com/embed/EXeTwQWrcwY'
  },
  {
    id: 6,
    title: 'Pulp Fiction',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNGNhMDIzZTUtNTBlZi00MTRlLWFjM2ItYzViMjE3YzI5MjljXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    rating: 8.9,
    year: 1994,
    description: 'The lives of two mob hitmen, a boxer, a gangster and his wife, and a pair of diner bandits intertwine in four tales of violence and redemption.',
    trailerUrl: 'https://www.youtube.com/embed/s7EdQ4FqbhY'
  },
];

const categories = ['Action', 'Comedy', 'Drama', 'Sci-Fi', 'Horror', 'Documentary'];

const Content: React.FC = () => {
  const navigate = useNavigate();
  
  const handleCategoryClick = (category: string) => {
    navigate(`/browse?genre=${category}`);
  };
  
  return (
    <main>
      <div className="hero-banner">
        <div className="hero-content container">
          <h2 className="hero-title">Welcome to Quick Flick</h2>
          <p className="hero-subtitle">Unlimited movies, TV shows, and more.</p>
          <Link to="/browse" className="btn btn-primary hero-btn">Start Watching</Link>
        </div>
      </div>
      
      <section className="featured-section">
        <div className="container">
          <h2 className="section-title">Featured Movies</h2>
          <div className="movie-grid">
            {movies.map((movie) => (
              <MovieCard
                key={movie.id}
                title={movie.title}
                imageUrl={movie.imageUrl}
                rating={movie.rating}
                year={movie.year}
                description={movie.description}
                trailerUrl={movie.trailerUrl}
              />
            ))}
          </div>
        </div>
      </section>
      
      <section className="categories-section">
        <div className="container">
          <h2 className="section-title">Browse by Category</h2>
          <div className="categories-grid">
            {categories.map((category, index) => (
              <div 
                key={index} 
                className="category-item"
                onClick={() => handleCategoryClick(category)}
                style={{ cursor: 'pointer' }}
              >
                {category}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Content; 